import React from 'react'
import {message} from "antd";
import style from "../Home.module.css";
import contentStyle from "../Content.module.css";
import BookkeepingManageInfo from "./BookkeepingManageInfo";
import Util from "../../../utils/utils";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import PermissionUtils from "../../../utils/permissionUtils";

class BookkeepingManage extends React.Component {
    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (Util.isEmpty(userName)) {
            this.props.history.push("/login")
        } else {
            let userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
            if (userRole !== 0) {
                message.error("你没有权限访问!");
                this.props.history.push("/home");
            } else {
                PermissionUtils.getUserPermission(this, '100018');
            }
        }
    }

    render() {
        return (
            <div className={style['home']}>
                <Header history={this.props.history}/>
                <LeftMenu history={this.props.history}/>
                <div className={contentStyle['content']} id='content'>
                    <div className={contentStyle['content_info']}>
                        <BookkeepingManageInfo history={this.props.history}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default BookkeepingManage;